import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PerioComponent } from './perio.component';
import { PerioToothComponent } from './perio-tooth/perio-tooth.component';
import { PerioToothDetailsComponent } from './perio-tooth-details/perio-tooth-details.component';
import { ProbingDepthSummaryComponent } from './depth-summary/probing-depth-summary.component';
import { ProbingDepthSegmentsSummaryComponent } from './depth-segments-summary/probing-summary.component';
import { ToothSummaryComponent } from './tooth-summary/tooth-summary.component';

import { NoteCompactModule } from '../notes/note-compact/note-compact.module';

import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import {MatMenuModule} from "@angular/material/menu";
import {MatTooltipModule} from "@angular/material/tooltip";
import { LucideIconsModule } from '../../shared/lucide-icons.module';

@NgModule({
    declarations: [
        PerioComponent,
        PerioToothComponent,
        PerioToothDetailsComponent,
        ProbingDepthSummaryComponent,
        ProbingDepthSegmentsSummaryComponent,
        ToothSummaryComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        NoteCompactModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatIconModule,
        LucideIconsModule,
        MatMenuModule,
        MatTooltipModule,
    ],
    exports: [
        PerioComponent
    ]
})
export class PerioModule { }
